import { Component, OnInit, Input, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';

import { TransferChallanInService, CommonService, ClientWalkInService, SubscribeService, BranchService } from '../../../services/index';
import { TransferChallanInModal } from '../../../model/index';


import { Subject }           from 'rxjs/Subject';
// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';


@Component({
    selector: 'add-transfer-challan-out-tab',
    templateUrl: './addTransferChallanIn.component.html'
})
export class AddTransferChallanInComponent implements OnInit {
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    //@Input() params;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        if (!val['hv_username']) {
            val['out_type'] = 'Branch';
        }
        if (val['tc_out_id']) {
            val['hasTCOutNo'] = true;
            val['tc_out_no'] = val['tc_no'];
        }
        this._params = val;
        this.setPageData();
    }
    public mode: string;
    branchCTrl: FormControl;
    tcNoCtrl: FormControl;
    tcNoList: any[] = [];
    itemsList: any[] = [];
    tcInList: any[] = [];
    columns = [];
    toggleCol = [];
    //@Output() transferChellInUpdateEvent = new EventEmitter();

    @Input() tcInData: TransferChallanInModal[] = [];
    @Input() tcInRow: TransferChallanInModal[] = [];
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('tcAutoComp') tcAutoComp;
    @ViewChild('itemsAutoComp') itemsAutoComp;

    isLoading: boolean = false;
    minDate: any;
    tcoDate: any;

    constructor(
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private BranchService: BranchService,
        private tcInService: TransferChallanInService,
        private clientWalkInService: ClientWalkInService, public subscribeService: SubscribeService
    ) {
        function hasValidTcNo(input: FormControl) {
            let tcOutID = input.value;
            let femp =_.find(this.tcNoList, { 'tc_out_id': tcOutID });
            if(femp)
                return null;
            return { inValidTcNo: true };
        }
        this.tcNoCtrl = new FormControl('', [
            Validators.required,
            hasValidTcNo.bind(this)
        ]);
        this.getTcNoList();
    }

    reorderable: boolean = true;

    page = {
        limit: 50,
        count: 0,
        offset: 0,
        orderBy: 'model_id',
        orderDir: 'asc'
    };

    tcOutList = [];

    ngOnInit(): void {

        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 90, minWidth: 90, maxWidth: 90, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Model', prop: 'name', width: 140, minWidth: 140, maxWidth: 140, toggle: true },
            { name: 'Brand', prop: 'brand_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name',width:150,minWidth:150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name',width:150,minWidth:150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Color', prop: 'color_name', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology', width: 140, minWidth: 140, maxWidth: 140, toggle: true },
            { name: 'Serial No', prop: 'serial_no', width: 140, minWidth: 140, maxWidth: 140, toggle: true },
            { name: 'MRP', prop: 'mrp', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'Given Qty', prop: 'given_qty', width: 120, minWidth: 120, maxWidth: 120, toggle: true, cellClass: 'cell-right' },
            { name: 'Recieved Qty', prop: 'recieved_qty', width: 120, minWidth: 120, maxWidth: 120, toggle: true, cellClass: 'cell-right' }
            /*{ name: 'Action', prop: 'action', maxWidth: 90, sortable: false, cellTemplate: this.editDeleteTemplate }*/
        ];
        this.toggleCol = Object.assign({}, this.columns);

        if (this._params['mode'] == 'Add' || !this._params['tc_in_no']) {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());

            this.tcInData['tc_in_date'] = new Date();
            this.getAutoNumber();
        }
    }
    getAutoNumber() {
        let that = this,
            tcOInDate = moment(this.tcInData['tc_in_date']).format('YYYY-MM-DD'),
            params = {
                account_type: 'transferChallanIn',
                date: tcOInDate,
            };
        this.commonService.getAutoNumber(params)
            .then(function(res: any) {
                that.tcInData['tc_in_no'] = res['auto_no'];
            });
    }
    getTcNoList() {
        let that = this;
        this.commonService.getTcNoList()
            .then(function(res: any) {
                if (res && res.data) {
                    that.tcNoList = res.data;
                    that.tcNoCtrl.setValue(that._params['tc_out_id']);
                }
            });
    }

    itemFn(model_id: any) {
        if (this.itemsList != undefined) {
            if (model_id && this.itemsList.length > 0) {
                let fitem = _.find(this.itemsList, { 'model_id': model_id });
                this.itemsList['name'] = fitem.itemsList; //ANOTHER FIELD
                this.tcInRow['avail_qty'] = fitem.avail_qty;
                this.tcInRow['item_name'] = fitem.name;
                return fitem['name'];
            }
        }
        return '';

    }
    setPageData(): void {
        let that = this;
        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.tcInData = this._params;
            if (mode == 'Add') {
                if (this._params['tc_no']) {
                    that.tcNoCtrl.setValue(that._params['tc_out_id']);
                    this.tcInData['hv_username'] = this._params['hv_username'];
                    this.onChangeTcNo(this._params);
                }
                this.tcInData['btnTxt'] = this._params['btnTxt'];
            } else {
                this.mode=mode;
                this.tcInData['tc_out_date'] = new Date(this._params['tcout_date']);
                this.tcInData['tc_in_date'] = new Date(this._params['tc_in_date']);//new Date();
                this.tcInData['hv_username'] = this._params['hv_username'];
                this.getEditTcInDetails(this._params);
            }
        }
    }
    displayFn(tcOutID: any) {
        if (tcOutID && this.tcNoList.length > 0) {
            let fhalist = _.find(this.tcNoList, { 'tc_out_id': String(tcOutID) });
            this.onChangeTcNo(fhalist);
            return fhalist['tc_no'];
        }
        return '';
    }

    getEditTcInDetails(data: any): void {
        let params = {
            company_id: data.branch_id,
            tc_in_id: data.tc_in_id,
            tc_out_id: data.tc_out_id
        };

        let that = this;
        this.tcInService
            .getEditDetails(params)
            .then(function(res: any) {

                that.page.count = res.totCnt;
                that.tcInList = res.data;
                that.tcInData['from_branch'] = res.data[0]['from_branch'];
                that.tcInData['tc_out_date'] = res.data[0]['tcoutdate'];
                that.tcInData['tc_out_no'] = res.data[0]['tc_out_no'];
            });
    }

    onSaveTransferChellanIn() {
        let that = this;
        let rowDet = that.tcInList;
        let tcFormDet = JSON.stringify(rowDet);
        let tcInDet = that.tcInData;
        if (tcInDet['tc_in_no'] == undefined || tcInDet['tc_in_no'] == "") {
            swal(
                'ERROR',
                'Please Enter Tc Out No',
                'error'
            )
        }
        let tcinno = tcInDet['tc_in_no'];
        let tcoutid = tcInDet['tc_out_id'];
        let tcindate = tcInDet['tc_in_date'];
        let company_id = tcInDet['company_id'];
        let tcInDate = moment(tcindate).format('YYYY-MM-DD');
        let tcoutdate = tcInDet['tc_out_date'];
        let tcOutDate = moment(tcoutdate).format('YYYY-MM-DD');
        if (rowDet.length == 0) {
            swal(
                'ERROR',
                'Please Enter Atleast One Details',
                'error'
            );
            return false;
        }
        let params = {
            tc_out_id: tcoutid,
            tc_in_no: tcinno,
            tc_indate: tcInDate,
            companyid: company_id,
            out_type: tcInDet['out_type'],
            requested_by: tcInDet['requested_by'],
            particulars: tcFormDet,
            mode: 'Add'
        };
        this.isLoading = true;
        this.tcInService.addTransferChellanIn(params).then(function(res: any) {
            that.isLoading = false;
            if (res.success) {
                swal('SUCCESS', res.message,'success');
                that.subscribeService.subReloadTransferInListGrid();
                that.subscribeService.subScribeDeleteActiveTab();
                that.tcInList = [];
                that.tcInData = [];
            } else {
                swal(
                    'ERROR',
                    res.message,
                    'error'
                );
            }
        });
    }

    onChangeTcNo(tc_details: any) {
        if (tc_details && tc_details.tc_no) {
            let that = this,
                params = {
                    tcno: tc_details.tc_no,
                    tc_out_id: tc_details.tc_out_id
                };
            this.tcInService.getTcNoData(params)
                .then(function(res: any) {
                    that.tcInList = res.data;
                    that.tcInData['tc_out_date'] = res.data[0]['tcoutdate'];
                    //that.tcInData['tc_out_id'] = res.data[0]['tc_out_id'];
                    that.tcInData['from_branch'] = res.data[0]['from_branch'];
                    that.tcInData['company_id'] = res.data[0]['from_company_id'];
                    that.page.count = res.totCnt;
                });
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/transferChallanIn/addTransferChallanIn.component.ts